import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { LogOut, Settings } from "lucide-react";
import { format } from "date-fns";
import { Link } from "react-router-dom";
import { createPageUrl } from "@/utils";
import { DoctorOrPracticeOwner } from "@/components/auth/RoleGuard";

export default function UserProfileCard({ user, onLogout }) {
  const getInitials = (name) => {
    if (!name) return "U";
    const names = name.split(" ");
    return names.length > 1
      ? `${names[0][0]}${names[names.length - 1][0]}`.toUpperCase()
      : name[0].toUpperCase();
  };

  return (
    <div className="p-2">
      <div className="flex items-center gap-4 mb-4">
        <Avatar className="h-12 w-12">
          <AvatarImage src={user?.picture} />
          <AvatarFallback className="text-lg bg-slate-200">
            {getInitials(user?.name)}
          </AvatarFallback>
        </Avatar>
        <div>
          <p className="font-semibold text-slate-900">{user?.name || "User"}</p>
          <p className="text-sm text-slate-500">{user?.email}</p>
        </div>
      </div>
      <div className="space-y-3">
        <div className="flex justify-between items-center text-sm">
          <span className="text-slate-500">Role</span>
          <Badge
            variant={user?.role === "admin" ? "default" : "secondary"}
            className="capitalize"
          >
            {user?.role || "User"}
          </Badge>
        </div>
        <div className="flex justify-between items-center text-sm">
          <span className="text-slate-500">Member since</span>
          <span className="font-medium text-slate-700">
            {user?.createdAt
              ? format(new Date(user.createdAt._seconds * 1000), "MMM yyyy")
              : "N/A"}
          </span>
        </div>
      </div>
      <div className="mt-4 pt-4 border-t border-slate-200 space-y-2">
        <DoctorOrPracticeOwner>
          <Button variant="ghost" className="w-full justify-start gap-2" asChild>
            <Link to={createPageUrl("Settings")}>
              <Settings className="w-4 h-4" /> Manage Account
            </Link>
          </Button>
        </DoctorOrPracticeOwner>
        <Button
          variant="ghost"
          onClick={onLogout}
          className="w-full justify-start gap-2 text-red-500 hover:text-red-600 hover:bg-red-50"
          data-testid="logout-btn"
        >
          <LogOut className="w-4 h-4" /> Logout
        </Button>
      </div>
    </div>
  );
}
